import { createWebHashHistory, createRouter } from "vue-router";
import Search from "../views/search.vue";
import Esg from "../components/esg.vue"
import EquityAnalyst from "../components/equity-analyst.vue"
import EquityNote from "../components/equity-note.vue";
import EquityCompany from "../components/equity-company.vue"
import DynamicComponentRenderer from "../components/dynamic-component-renderer.vue"
import MultiComponentLoader from "../components/multi-component-loader.vue"

const routes = [
  {
    path: "/",
    name: "Search",
    component: Search,
  },
  {
    path: "/esg",
    name: "Esg",
    component: Esg,
  },
  {
    path: "/equity-analyst",
    name: "Equityanalyst",
    component: EquityAnalyst,
  },
  {
    path: "/equity-note",
    name: "EquityNote",
    component: EquityNote,
  },
  {
    path: "/equity-company",
    name: "EquityCompany",
    component: EquityCompany,
  },
  {
    path: "/esg/:componentName",
    name: "DynamicESGComponent",
    component: DynamicComponentRenderer,
  },
  {
    // This is just for poc and can be removed later
    path: "/multi-loader",
    name: "MultiComponentLoader",
    component: MultiComponentLoader,
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router